import { useEffect } from 'react';
import { ClarityProxy } from 'util/clarity';
import { getEnv } from 'util/getEnv';

const InitClarity = ({ children }) => {
  useEffect(() => {
    ClarityProxy.init(getEnv('REACT_APP_MS_CLARITY_PROJECT_ID'));
  }, []);

  return children;
};

export default InitClarity;
